import React from 'react';
import '../assets/css/main.css';

function Popup({ className = "", title, isOpen, onClose, children, footer }) {
  const popupClasses = ["popup-box", className].filter(Boolean).join(" ");
  
  if (!isOpen) return null;

  return (
    <div className="popup-overlay">
      <div className={popupClasses}>
        <div className="popup-title">
          <h2>{title}</h2>
        </div>
        <div className="popup-body">
          {children}
        </div>
        <div className="popup-footer">
          {/* {footer ?? <button onClick={onClose}>Close</button>} */}
          {footer ?? <></>}
        </div>
      </div>
    </div>
  );
}

export default Popup;